import axios from "axios";

const uploadMixin = {
  methods: {
    onOversize(file) {
      // console.log(file);
      const fileSize = Math.floor(parseInt(file.size) / 1024)
      this.$toast(`文件大小(${fileSize}) 不能超过 5000kb`);
    },
    _afterRead(file, type, fileList, fileList1){
      // 同时上传多张图片时file是array
      if (Array.isArray(file)) {
        file.forEach(item => {
          this.__afterRead(item, type)
        })
        return
      }
      this.__afterRead(file, type, fileList, fileList1)
    },
    async __afterRead(file, type, fileList, fileList1) {
      try {
        const token = await this.$api.post("contract/member/file/update/token", { type: type })
        const fileNames = /.+\.([^.]*$)/.exec(file.file.name)
        let ext = ''
        if (fileNames && fileNames.length >= 2) {
          ext = fileNames[1]
        }
        let formData = new FormData()
        formData.append('token', token.token)
        formData.append('file', file.file)
        formData.append('key', `${token.file_path}.${ext}`)

        const res = await axios.post("https://up-z0.qiniup.com", formData)
        fileList1.push(res.key)
      } catch (error) {
        console.log(error);
        // 清除预览
        for (let i = 0; i < fileList.length; i++) {
          if (fileList[i].file.name === file.file.name) {
            fileList.splice(i,1)
            break
          }
        }
        this.$toast('图片上传失败，请重新上传')
      }
    },
    deleteFile(file, fileList1){
      for (let i = 0; i < fileList1.length; i++) {
        if (fileList1[i].endsWith(file.file.name)) {
          fileList1.splice(i,1)
          break
        }
      }
    },
  }
}

export {uploadMixin}
